var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-upload"},[_c('el-upload',_vm._b({attrs:{"action":_vm.url(),"accept":_vm.$attrs.accept || _vm.all_suffix,"list-type":"list","before-upload":_vm.before,"on-change":function (file, fileList) {
                _vm.change(file);
            },"before-remove":function (file, fileList) {
                return _vm.before_remove(file);
            },"file-list":_vm.fileList},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,scopeSlotName){return {key:scopeSlotName,fn:function(scope){return [_vm._t(scopeSlotName,null,null,scope)]}}})],null,true)},'el-upload',_vm.$attrs,false),[_vm._l((_vm.$slots),function(_,slotName){return _vm._t(slotName,null,{"slot":slotName})})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-274a1619","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/custom-upload.vue
// module id = 736
// module chunks = 125